import {getOrderTotalNumeric} from '../../selectors/OrderSummarySelectors';
import {
  getAcquirerBankCountryCode,
  getGooglePayEnvironment,
  getGooglePayJwt,
  getGooglePayMerchantId,
  getGooglePayPublicKey,
} from '../../selectors/PaymentOptionSelectors/GooglePay/GooglePaySelectors';
import {getSettings} from '../../selectors/selectors';
import bigQueryMetricRecorder from '../../tracking/bigQueryMetricRecorder';
import Track from '../../utils/tracking';
import * as types from '../action-types';
import {placeOrder} from '../placeOrderActions';
import {startOrderProcessing, stopOrderProcessing} from '../site-actions';

const allowedCardNetworks = window?.start?.settings?.googlepay_allowed_card_networks
  || ['AMEX', 'DISCOVER', 'JCB', 'MASTERCARD', 'VISA'];

const tokenizationSpecification = {
  type: 'DIRECT',
  parameters: {
    protocolVersion: 'ECv2',
  },
};

const cardPaymentMethod = {
  type: 'CARD',
  tokenizationSpecification,
  parameters: {
    allowedCardNetworks,
    allowedAuthMethods: ['CRYPTOGRAM_3DS', 'PAN_ONLY'],
    billingAddressRequired: true,
    billingAddressParameters: {
      format: 'FULL',
      phoneNumberRequired: true,
    },
  },
};

const googlePayBaseConfiguration = {
  apiVersion: 2,
  apiVersionMinor: 0,
  allowedPaymentMethods: [cardPaymentMethod],
};

export const transactionInfo = {
  totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
};

const paymentDataRequest = {
  ...googlePayBaseConfiguration,
  allowedPaymentMethods: [cardPaymentMethod],
  transactionInfo,
};

export const onGooglePayLoaded = () => (dispatch, getState) => {
  const googlePayPublicKey = getGooglePayPublicKey(getState());
  const googlePayMerchantId = getGooglePayMerchantId(getState());
  const googlePayEnvironment = getGooglePayEnvironment(getState());
  const authJwt = getGooglePayJwt(getState());
  const bankCountryCode = getAcquirerBankCountryCode(getState());
  
  tokenizationSpecification.parameters.publicKey = googlePayPublicKey;
  transactionInfo.totalPrice = getOrderTotalNumeric(getState()).toFixed(2);
  transactionInfo.currencyCode = getState().start.orderTotal.currencyCode;
  transactionInfo.countryCode = bankCountryCode;
  
  paymentDataRequest.merchantInfo = {
    merchantName: getSettings(getState())?.googlepay_merchant_name || 'The Hut.com Ltd',
    merchantId: googlePayMerchantId,
    merchantOrigin: window.location.hostname,
    authJwt,
  };
  
  window.paymentsClient = new window.google.payments.api.PaymentsClient({environment: googlePayEnvironment});
  
  return window.paymentsClient.isReadyToPay(googlePayBaseConfiguration)
    .then((response) => {
      if (!response.result) {
        throw new Error('UNABLE TO PAY WITH GOOGLEPAY');
      }
      window.paymentsClient.prefetchPaymentData(paymentDataRequest);
    });
};

export const setGooglePayPaymentData = googlePayPaymentData => ({
  type: types.SET_GOOGLE_PAY_PAYMENT_DATA,
  googlePayPaymentData,
});

export const onSubmit = () => (dispatch, getState) => {
  transactionInfo.totalPrice = getOrderTotalNumeric(getState()).toFixed(2);
  transactionInfo.currencyCode = getState().start.orderTotal.currencyCode;
  transactionInfo.totalPriceStatus = 'FINAL';
  return window.paymentsClient.loadPaymentData(paymentDataRequest)
    .then((paymentData) => {
      paymentData.method = 'googlepay';
      dispatch(startOrderProcessing());
      dispatch(setGooglePayPaymentData(paymentData));
      dispatch(placeOrder());
    })
    .catch(() => {
      try {
        bigQueryMetricRecorder('Googlepay', [{name: 'Googlepay status', value: 'CANCELLED'}], [], 'impression');
      } catch (error) {
        Track.track(error);
      }
      dispatch(stopOrderProcessing());
    });
};
